import { db } from './../../../config/Fire';
import * as Constants from './../../../constants/nodes_database';

export const SET_PLACES = 'SET_PLACES';

export const setPlaces = payload => ({ type: SET_PLACES, payload });

export const setPlacesToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.PLACES}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var places = snapshot.val();
                    dispatch(setPlaces(places));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setPlaces(null));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setPlaces(null));
        });
    };
};